import { toast } from "react-toastify";

export const ToasterNotification = (type: any, message: string) => {
  if (type == "success")
    return toast.success(message, {
      position: toast.POSITION.BOTTOM_CENTER,
    });
  else
    return toast.error(message, {
      position: toast.POSITION.BOTTOM_CENTER,
    });
};